import axios from 'axios';
import VoilaConfig from '../config';
import { openModal } from './ModalLoginActions';

export const ADD_TO_FAVORITES = 'ADD_TO_FAVORITES';
export const REMOVE_FROM_FAVORITES = 'REMOVE_TO_FAVORITES';
export const FETCH_FAVORITES = 'FETCH_FAVORITES';
export const RECEIVE_FAVORITES = 'RECEIVE_FAVORITES';
export const FETCH_FAVORITES_OTHER = 'FETCH_FAVORITES_OTHER';
export const RECEIVE_FAVORITES_OTHER = 'RECEIVE_FAVORITES_OTHER';

const FAVORITES_API_URL = `${VoilaConfig.API_URL}/citizen/account/favorites`;

export function addToFavorite(pProduct) {
  return (dispatch, getState) => {
    let { user } = getState();
    let pid=user.data.user_id

    if (user.authenticated) {
      return axios
        .post(FAVORITES_API_URL, { product_id: pProduct.id, user_id: pid }, {
          headers: {
            'Authorization': `Bearer ${user.data.token}`
          }
        })
        .then((res) => {
          dispatch({
            type: ADD_TO_FAVORITES,
            item: pProduct
          })
        });
    } else {
      dispatch(openModal());
    }
  }
};


export function removeFromFavorite(pProductId) {
  return (dispatch, getState) => {
    let { user } = getState();
    let pid=user.data.user_id

    if (user.authenticated) {
      return axios
        .delete(FAVORITES_API_URL, {
          params: { product_id: pProductId, user_id: pid },
          headers: {
            'Authorization': `Bearer ${user.data.token}`
          }
        })
        .then(() => {
          dispatch({
            type: REMOVE_FROM_FAVORITES,
            item: pProductId
          })
        })
    } else {
      dispatch(openModal());
    }
  }
};

export function getFavorites() {
  return (dispatch, getState) => {
    let { user } = getState();
    let pid=user.data.user_id


    if (user.authenticated) {
      dispatch({
        type: FETCH_FAVORITES
      })

      console.log(`${FAVORITES_API_URL}?per_page=100`);
      return axios
        .get(`${FAVORITES_API_URL}?per_page=100`, {
          params: { user_id: pid },
          headers: {
            'Authorization': `Bearer ${user.data.token}`
          }
        })
        .then(async (res) =>  {
          let totalPages = res.headers['x-wp-totalpages'];
          console.log('x');
          console.log(res.data);
          console.log('x2');
          dispatch({
            type: RECEIVE_FAVORITES,
            items: res.data
          });

          for (let currentPage = 2; currentPage <= totalPages; currentPage++) {
            let results = await axios
              .get(`${FAVORITES_API_URL}?per_page=100&page=${currentPage}`, {
                headers: {
                  'Authorization': `Bearer ${user.data.token}`
                }
              });
            dispatch({
              type: RECEIVE_FAVORITES,
              items: results.data
            });
          }
        });
    } else {
      dispatch(openModal());
    }
  }
};

export function getFavoritesOther() {
  return (dispatch, getState) => {
    let { user } = getState();
    //let pid=user.data.user_id

    // const viola_url='http://52.200.144.109:3006/favorites';
    const viola_url='https://www.voilacatalog.com/favorites';
    const current_url=window.location.href;
    const uid_from_url=''+current_url.replace(viola_url+'?list=', '');
    let pid=uid_from_url;
    if (user.authenticated) {
            dispatch({
              type: FETCH_FAVORITES_OTHER
            })

      if(pid!=''&&pid!=viola_url&&pid!='https://www.voilacatalog.com/'){
       // if(pid!=''&&pid!=viola_url&&pid!='http://52.200.144.109:3006/'){
        return axios.get(`${VoilaConfig.API_URL}/wp/v2/users/`+pid, {
            params: { },
            headers: {
              'Authorization': `Bearer ${user.data.token}`
            }
          })
          .then(async (res) =>  { 
            let uname=res.data.name;
            console.log(res);
            console.log('xxxxxxxx');
            axios
              .get(`${FAVORITES_API_URL}?per_page=100`, {
                params: { user_id: pid },
                headers: {
                  'Authorization': `Bearer ${user.data.token}`
                }
              })
              .then(async (res) =>  {
                let totalPages = res.headers['x-wp-totalpages'];
                console.log('x##');
                console.log(res.data);
                console.log('x##2');
                dispatch({
                  type: RECEIVE_FAVORITES_OTHER,
                  items: res.data,
                  uname: uname
                });

                for (let currentPage = 2; currentPage <= totalPages; currentPage++) {
                  let results = await axios
                    .get(`${FAVORITES_API_URL}?per_page=100&page=${currentPage}`, {
                      headers: {
                        'Authorization': `Bearer ${user.data.token}`
                      }
                    });
                  dispatch({
                    type: RECEIVE_FAVORITES_OTHER,
                    items: results.data,
                    uname: uname
                  });
                }
              });
            });
       } else return false;
    } else {
      dispatch(openModal());
    }

  }
};


// WEBPACK FOOTER //
// ./src/actions/FavoritesActions.js